<style lang="scss" scoped>
.cm-card {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: #000000d9;
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: "tnum";
    position: relative;
    background: #fff;
    border-radius: 2px;

    .cm-card-body {
        padding: 24px 12px;

        >:before {
            display: table;
            content: "";
        }

        >:after {
            display: table;
            clear: both;
            content: "";
        }
    }

    .cm-card-head {
        min-height: 32px;
        margin-bottom: -1px;
        padding: 0 12px;
        color: #000000d9;
        font-weight: 500;
        font-size: 16px;
        background: transparent;
        border-bottom: 1px solid #f0f0f0;
        border-radius: 2px 2px 0 0;

        >:before {
            display: table;
            content: "";
        }

        >:after {
            display: table;
            clear: both;
            content: "";
        }

        .cm-card-head-wrapper {
            display: flex;
            align-items: center;

            .cm-card-head-title {
                display: inline-block;
                flex: 1;
                padding: 8px 0;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-weight: bold;
                font-size: 15px;
            }

            .cm-card-extra {
                float: right;
                margin-left: auto;
                padding: 8px 0;
                color: #000000d9;
                font-weight: 400;
                font-size: 14px;
            }
        }
    }
}

.cm-card-small {
    >.cm-card-head {
        min-height: 26px;
        padding: 0 7px;
        font-size: 14px;
    }

    >.ant-card-body {
        padding: 12px 8px;
    }
}

.cm-card-bordered {
    border: 1px solid #f0f0f0;
}

.cm-card~.cm-card {
    margin-top: 6px
}
</style>
<template>
    <div :class="classname" :style="{ 'border-radius': 'number' == typeof radius ? radius + 'px' : radius }">
        <div class="cm-card-head">
            <div class="cm-card-head-wrapper">
                <div class="cm-card-head-title">
                    <slot name="title">{{ title }}</slot>
                </div>
                <div class="cm-card-extra">
                    <slot name="extra"></slot>
                </div>
            </div>
        </div>
        <div class="cm-card-body">
            <slot name="default"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cm-card',
    data() {
        return {
            classname: {'cm-card': true, 'cm-card-bordered': this.bordered == true}
        };
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        bordered: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: 'default'
        },
        radius: {
            type: [String, Number],
            default: 0
        }
    },
    watch: {
        size: {
            handler(v) {
                if (v && v != 'default') {
                    this.classname['cm-card-' + v] = true
                }
                else {
                    this.classname['cm-card-' + v] = false
                }
            },
            immediate: true
        }
    },
    mounted() {

    },
    methods: {

    },
};
</script>


// WEBPACK FOOTER //
// src/components/CmCard/index.vue